import Vue from 'vue'
import store from 'public/store'
import { ENV } from '../../config'
import { buttonAuthTextReportQt } from '../../utils/qt-report'

const menus = store.getters.permission.menus

const KyeButton = Vue.component('kye-button', {
  functional: true,
  render (h, self) {
    let needAuth = localStorage.getItem('GLOBAL_AUTH_STATUS') || 0
    if (ENV === 'prd' || ENV === 'uat' || needAuth === '1') {
      const { attrs } = self.data
      if (attrs && self.props.auth) {
        attrs.auth = self.props.auth
        if (!self.props.auth.startsWith('crm$$')) {
          attrs.disabled = !menus.includes(self.props.auth) || attrs.disabled
        }
      }
    }
    // 自定义按钮的click事件，判断权限编码是否以BT开头并执行qt上报数据
    const clickHandler = (self) => {
      setTimeout(() => {
        try {
          const buttonAuth = self.props.auth
          if (buttonAuth) {
            if (buttonAuth.indexOf('BT') === 0) {
              const text = self.children && self.children[0] && self.children[0].text
              buttonAuthTextReportQt(buttonAuth, text)
            }
          }
        } catch (error) {
          console.error('【kye-button-clickHandler】:', error)
        }
      }, 200)
    }
    let originalClick = self.listeners.click
    // 自定义 button 组件 click 事件
    self.data.on = {
      ...self.data.on,
      click: (event) => {
        clickHandler(self)
        if (originalClick && typeof originalClick === 'function') {
          originalClick(event)
        }
      }
    }
    return h('el-button', self.data, self.children)
  },
  props: {
    auth: String
  }
})

export default KyeButton



// WEBPACK FOOTER //
// ./src/public/components/kye-button/index.js